import React, { useState } from "react";
import { Send } from "lucide-react";
import emailjs from "@emailjs/browser";
import { usePortfolio } from "../../contexts/PortfolioContext";

const Contact = () => {
  const { portfolioData } = usePortfolio();
  const personalInfo = portfolioData.personalInfo || {};
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus({
        type: "warning",
        message: "Please fill in your name, email, and message.",
      });
      return;
    }

    setSending(true);
    setStatus(null);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: form.name,
          from_email: form.email,
          message: form.message,
          to_email: personalInfo.email || "mr.auriorajaa@gmail.com",
          reply_to: form.email,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      setForm({ name: "", email: "", message: "" });
      setStatus({
        type: "success",
        message: "Thanks for reaching out. I usually reply within a day or two.",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error?.text ||
          "The message could not be sent. Please email me directly instead.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-card">
      <h3 className="contact-card-heading">Write me a message</h3>

      <form onSubmit={handleSubmit} noValidate>
        <div className="contact-form-row">
          <div className="form-field">
            <label className="form-label" htmlFor="contact-name">
              Your name
            </label>
            <input
              id="contact-name"
              className="public-input"
              name="name"
              type="text"
              value={form.name}
              onChange={handleChange}
              placeholder="Aurio's next collaborator"
              autoComplete="name"
            />
          </div>

          <div className="form-field">
            <label className="form-label" htmlFor="contact-email">
              Email address
            </label>
            <input
              id="contact-email"
              className="public-input"
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="you@company.com"
              autoComplete="email"
            />
          </div>
        </div>

        <div className="form-field">
          <label className="form-label" htmlFor="contact-message">
            Message
          </label>
          <textarea
            id="contact-message"
            className="public-textarea"
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Tell me about the role, project, or idea."
            rows={5}
          />
        </div>

        <button
          type="submit"
          className="btn contact-submit"
          disabled={sending}
        >
          <Send size={16} />
          {sending ? "Sending..." : "Send message"}
        </button>

        {status && (
          <div
            className={`public-alert public-alert--${status.type}`}
            role="status"
            aria-live="polite"
          >
            {status.message}
          </div>
        )}
      </form>
    </div>
  );
};

export default Contact;
